// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
// By default we import all the components.
// Only reserve the components on demand and remove the rest.
// Style is always required.
import Cube from 'cube-ui'
import App from './App'
import router from './router'
import store from './store'
import './icons' // icon
import VueProgressBar from 'vue-progressbar'
// import fastClick from 'fastclick' // 处理移动端click事件300毫秒延迟
import './permission' // 权限控制器
import 'lib-flexible' // 屏幕自适应
import './assets/styles/border.css' // border 1物理像素
import tips from './components/js/tips' // tips导入
import * as filters from './filters' // global filter
import Vconsole from 'vconsole'

import './utils/elComponents' // 按需引入element-ui
import 'element-ui/lib/theme-chalk/index.css';

// import ba from 'vue-ba' // 百度统计插件

if (process.env.NODE_ENV == 'development') {
  Vue.prototype.$vConsole = new Vconsole()
}

Vue.use(Cube)
Vue.use(tips) // tips导入
// Vue.use(ba, '2f09dd62369eb852fe48bdb15d95358c')

// 进度条配置
const options = {
  color: '#5fb73d',
  failedColor: '#5fb73d',
  thickness: '3px',
  transition: {
    speed: '0.5s',
    termination: 300
  }
}

Vue.use(VueProgressBar, options) // 进度条

// register global utility filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.config.productionTip = false
// fastClick.attach(document.body)

// input输入框自动获取焦点
Vue.directive('focus', {
  inserted: function (el) {
    // 聚焦元素
    el.focus()
  }
})

// var _hmt = window._hmt || []

// 添加百度统计
// router.beforeEach((to, from, next) => {
//   // ba.trackPageview(to.fullPath)
//   _hmt.push(['_trackPageview', to.fullPath])
//   next()
// })

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js